import React from "react";

// External
import styled from "@emotion/styled";

// Local
import { colorScheme } from "../../styled/styled";

const TooltipSmall = styled.div`
  position: absolute;
  background-color: ${colorScheme.neutralDarkColor};
  max-width: 240px;
  border-radius: 4px;
  padding: 12px;
  pointer-events: none;
  z-index: 1;
  opacity: 0.9;
  color: ${colorScheme.neutralLightColor};
`;

const TooltipOrgName = ({ orgName }) => {
  return (
    <TooltipSmall>
      <small>{orgName}</small>
    </TooltipSmall>
  );
};

export default TooltipOrgName;
